import cn from "classnames";
import * as Team from "src/state/modules/team";
import * as Event from "src/state/modules/event";
import { getBrowserTimezone } from "src/utils/date-utils";
import Styles from "./EventHeaderUpcoming.module.scss";
import Common from "./EventHeaderCommon.module.scss";
import { Avatar } from "src/components/atoms/Avatar/Avatar";
import { Sport } from "src/state/modules/team/types";
import { EventTime } from "../EventTime/EventTime";
import { Text } from "src/components/atoms/Text/Text";

type EventInfoProps = {
  event: Event.Event;
  team: Team.Team;
};

export default function EventHeaderUpcoming({ event, team }: EventInfoProps) {
  const displayTimezone = getBrowserTimezone();

  return (
    <>
      <div className={Styles.eventUpcomingHeader} data-testid="Event-Header-Upcoming">
        <div className={Styles.eventDateTime}>
          <EventTime event={event} />
        </div>
        <div
          className={cn(Styles.awayTeamInfo, Common.teamNameAndAvatarContainer, Common.awayTeamNameAndAvatarContainer)}
        >
          <div className={Common["avatar-container"]}>
            <Avatar.Team sportIcon={Sport.BASEBALL} hideSportIcon={true} size="medium" />
          </div>
          <Text color="white" weight="xbold" block={false} className={Common.teamName}>
            {event?.opponentTeam ? event.opponentTeam.name ?? "TBD" : event.title ?? "TBD"}
          </Text>
        </div>
        <div
          className={cn(Styles.homeTeamInfo, Common.teamNameAndAvatarContainer, Common.homeTeamNameAndAvatarContainer)}
        >
          <div className={Common["avatar-container"]}>
            <Avatar.Team sportIcon={Sport.BASEBALL} hideSportIcon={true} size="medium" />
          </div>
          <Text color="white" weight="xbold" block={false} className={Common.teamName}>
            {team.name}
          </Text>
        </div>
      </div>
    </>
  );
}
